module.exports = __webpack_public_path__ + "static/media/plate.9fb948d2.png";